import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Box, InputLabel } from "@mui/material";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export default function Calendar(props) {
  const { handleDate } = props;
  const [value, setValue] = useState(dayjs());
  const st = useSelector((state) => state.auth);

  useEffect(() => {
    if (value) {
      handleDate(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          width: "100%",
          maxWidth: 360,
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {!st?.userdata?.Date ? (
          <InputLabel id="calendar-label" sx={{ mb: 1 }}>
            Please Select Date
          </InputLabel>
        ) : null}
        <DateCalendar
          className="calendar"
          value={value}
          onChange={(newValue) => setValue(newValue)}
          disablePast={true}
          sx={{
            width: "100%",
            maxWidth: 320,
            "& .MuiPickersDay-root": {
              fontSize: { xs: "0.85rem", sm: "0.875rem" },
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}
